import React, { useState } from 'react';
import { Button, Card, Col, DatePicker, Divider, Form, FormInstance, Input, InputNumber, Popconfirm, Row, Select, Tooltip } from 'antd';
import './packing-stock-transfer.css';
import { CategorySubCategoryReq, ItemCategoryIdReq, PackingSTItems, QtyRequest, SizeIdRequest } from '@gtpl/shared-models/procurement-management'
import { ItemCategoryDropDownDto, ItemsDropDownDto, ItemSubCategoryDropDownDto, SizesDropDownDto } from '@gtpl/shared-models/masters';
import Table, { ColumnProps } from 'antd/lib/table';
import { UnitRequest } from '@gtpl/shared-models/common-models';
import { StockService } from '@gtpl/shared-services/procurement';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { EditOutlined, MinusCircleOutlined, PlusSquareOutlined, ClearOutlined } from '@ant-design/icons';
import { SaleOrderFileUploadResponse } from '@gtpl/shared-models/sale-management';
const { Option } = Select;
/* eslint-disable-next-line */
export interface PackingStockTransferItemsProps {
  itemCategories: ItemCategoryDropDownDto[];
  form: FormInstance<any>;
  stItems: any;
  addItems: (values) => void;
  availQty:number;
  isSo:boolean;
}
const dropDrownInfo = (key, value) => <Option key={key} value={key}>{value}</Option>
export function PackingStockTransferItems(
  props: PackingStockTransferItemsProps
) {
  const [itemSubCategories, setItemSubCategories] = useState<ItemSubCategoryDropDownDto[]>([]);
  const [items, setItems] = useState<ItemsDropDownDto[]>([]);
  // const [sizes, setSizes] = useState<SizesDropDownDto[]>([]);
  const [keyUpdate, setKeyUpdate] = useState<number>(1);
  const [alternateKeyUpdate, setAlternateKeyUpdate] = useState<number>(1);
  const [editItem, setEditItem] = useState<string>('Add');
  const [availableQty, setAvailableQty] = useState<number>(props.availQty);
  const [itemEdit, setItemEdit] = useState<boolean>(false);


  const skService = new StockService();

  // Table Columns
  const columns: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      fixed: 'left',
      render: (text, object, index) => (index + 1)
    },
    {
      title: 'Item Category',
      dataIndex: 'itemCategory',
      key: 'itemCategory',
      render: (value, row) => {
        const itemCategory = JSON.parse(value);
        row.itemCategoryId = itemCategory.itemCategoryId;
        return itemCategory.itemCategory;
      }
    },
    {
      title: 'Item Sub Category',
      dataIndex: 'itemSubCategory',
      key: 'itemSubCategory',
      render: (value, row) => {
        const itemSubCategory = JSON.parse(value)
        row.itemSubCategoryId = itemSubCategory.itemSubCategoryId;
        return itemSubCategory.itemSubCategory;
      }
    },
    {
      title: 'Item',
      dataIndex: 'item',
      key: 'item',
      render: (value, row) => {
        const item = JSON.parse(value)
        row.itemId = item.itemId;
        return item.itemName;
      }
    },
    // {
    //   title: 'Size',
    //   dataIndex: 'size',
    //   key: 'size',
    //   render: (value, row) => {
    //     const size = JSON.parse(value)
    //     row.sizeId = size.sizeId;
    //     return size.sizeName;
    //   }
    // },
    {
      title: 'Required Qty',
      dataIndex: 'requiredQty',
      key: 'requiredQty',
      className: props.isSo ? 'showColumn' : 'hideColumn',
      render: (value, row) => {
        return Number(value);
      }
    },
    {
      title: 'Available Qty',
      dataIndex: 'availableQty',
      key: 'availableQty',
      render: (value, row) => {
        return Number(value);
      }
    },
    {
      title: 'Issued Qty',
      dataIndex: 'issuedQty',
      key: 'issuedQty',
      render: (value, row) => {
        return Number(value);
      }
    },
    // {
    //   title: 'Unit Price',
    //   dataIndex: 'unitPrice',
    //   key: 'unitPrice',
    //   render: (value, row) => {
    //     return Number(value);
    //   }
    // },
    {
      title: 'Action',
      dataIndex: 'action',
      fixed: 'right',
      // width: '20%',
      render: (text, rowData, index) => (
        <span>
          <Tooltip placement="top" title='edit'>
            <EditOutlined className={'editSamplTypeIcon'} type="edit"
              onClick={() => {
                setEditForm(rowData, index);
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
          </Tooltip>
          <Divider type="vertical" />
          <Popconfirm title='Sure to delete?' onConfirm={e =>{deleteData(index);}}>
          
          <Tooltip placement="top" title='delete'>
            <MinusCircleOutlined 
              style={{ color: '#1890ff', fontSize: '14px' }} />
          </Tooltip>
          </Popconfirm>

        </span>)
    }
  ];

  const setEditForm = (rowData, index) => {
    if (rowData.saleOrderId) {
      props.form.setFieldsValue({
        saleOrderId: rowData.saleOrderId,
      });
    }
    setAvailableQty(rowData.availableQty);
    setItemEdit(true);
    props.form.setFieldsValue({
      itemCategory: rowData.itemCategory,
    });
    getItemSubCategories();
    props.form.setFieldsValue({
      itemSubCategory: rowData.itemSubCategory,
    });
    getItems();
    props.form.setFieldsValue({
      item: rowData.item
    });
    // getSizes();
   
    props.form.setFieldsValue({
      // size: rowData.size,
      requiredQty: rowData.requiredQty,
      issuedQty: rowData.issuedQty,
      index: index,
      unitPrice:rowData.unitPrice
    });
  }


  const deleteData = (index) => {
    props.stItems.splice(index, 1);
    props.addItems(props.stItems);
  }

  const getItemSubCategories = () => {
    const itemCategoryId = JSON.parse(props.form.getFieldValue('itemCategory')).itemCategoryId;
    const saleOrderId = props.form.getFieldValue('saleOrderId');
    console.log(saleOrderId);
    if (itemCategoryId) {
      props.form.setFieldsValue({ itemSubCategory: '', item: '', size: '', availableQty: 0, issuedQty: 0 })
      setItemSubCategories([]);
      setItems([]);
      const req = new ItemCategoryIdReq(itemCategoryId, Number(localStorage.getItem('unit_id')), saleOrderId);
      skService.getAvailableStockItemSubCategories(req).then((res) => {
        if (res.status) {
          setItemSubCategories(res.data);
        } else {
          setItemSubCategories([]);
        }
      }).catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setItemSubCategories([]);
      });
    }
  }


  const getItems = () => {
    const itemCategoryId = JSON.parse(props.form.getFieldValue('itemCategory')).itemCategoryId;
    const itemSubCategoryId = JSON.parse(props.form.getFieldValue('itemSubCategory')).itemSubCategoryId;
    const saleOrderId = props.form.getFieldValue('saleOrderId');
    if (itemCategoryId && itemSubCategoryId) {
      props.form.setFieldsValue({ item: '', availableQty: 0, issuedQty: 0 })
      setItems([]);
      const req = new CategorySubCategoryReq(itemCategoryId, itemSubCategoryId, Number(localStorage.getItem('unit_id')), saleOrderId);
      skService.getAvailableStockTransferItems(req).then((res) => {
        if (res.status) {
          setItems(res.data);
        } else {
          setItems([]);
        }
      }).catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setItems([]);
      });
    }
  }

  // const getSizes = () => {
  //   const itemCategoryId = JSON.parse(props.form.getFieldValue('itemCategory')).itemCategoryId;
  //   const itemSubCategoryId = JSON.parse(props.form.getFieldValue('itemSubCategory')).itemSubCategoryId;
  //   const itemId = JSON.parse(props.form.getFieldValue('item')).itemId;
  //   const saleOrderId = props.form.getFieldValue('saleOrderId');
  //   if (itemCategoryId && itemSubCategoryId && itemId) {
  //     props.form.setFieldsValue({ availableQty: 0, issuedQty: 0 })
  //     setSizes([]);
  //     const req = new SizeIdRequest(itemCategoryId, itemSubCategoryId, itemId, Number(localStorage.getItem('unit_id')), saleOrderId);
  //     skService.getAvailableStockSizes(req).then((res) => {
  //       if (res.status) {
  //         setSizes(res.data);
  //       } else {
  //         setSizes([]);
  //       }
  //     }).catch((err) => {
  //       AlertMessages.getErrorMessage(err.message);
  //       setSizes([]);
  //     });
  //   }
  // }

  const getAvailableQty = () => {
    const itemCategoryId = JSON.parse(props.form.getFieldValue('itemCategory')).itemCategoryId;
    const itemSubCategoryId = JSON.parse(props.form.getFieldValue('itemSubCategory')).itemSubCategoryId;
    const itemId = JSON.parse(props.form.getFieldValue('item')).itemId;
    // const sizeId = JSON.parse(props.form.getFieldValue('size')).sizeId;
    const saleOrderId = props.form.getFieldValue('saleOrderId');
    if (itemCategoryId && itemSubCategoryId && itemCategoryId) {
      props.form.setFieldsValue({ issuedQty: 0 })
      const req = new QtyRequest(itemCategoryId, itemSubCategoryId, itemId, 0, Number(localStorage.getItem('unit_id')), saleOrderId);
      skService.getAvailableTransferStockQty(req).then((res) => {
        if (res.status) {
          setAvailableQty(Number(res.data.physicalQuantity));
          props.form.setFieldsValue({ issuedQty: Number(res.data.physicalQuantity), unitPrice: Number(res.data.unitPrice)})
        } else {
          setAvailableQty(0);
        }
      }).catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setAvailableQty(0);
      });
    }
  };

  const onAddProduct = () => {
    props.form.validateFields().then((formFields) => {
      formFields.availableQty = availableQty;
      const exists = props.stItems.find(item => ((item.item === formFields.item) && (item.size === formFields.size)));
      if (itemEdit) {
        if (exists && exists.length > 1) {
          AlertMessages.getErrorMessage('Item already in list');
        } else {
          props.stItems.splice(formFields.index, 1, formFields)
          props.addItems(props.stItems);
        }
      } else {
        if (exists) {
          AlertMessages.getErrorMessage('Item already in list');
        } else {
          props.addItems([...props.stItems, formFields]);
        }
      }
      clearItems();
      setItemEdit(false);
      setAlternateKeyUpdate(alternateKeyUpdate + 1);
      setKeyUpdate(keyUpdate + 1);
    })
  }

  const clearItems = () => {
    props.form.resetFields();
    setAvailableQty(0);
  };




  return (
    <Card size="small" title={<span style={{ color: 'white' }} >Stock Transfer Items</span>}
      style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
      <Form layout="vertical" form={props.form} name="control-hooks">
        <Row gutter={24}>
          <Form.Item name="packingStockTransferItemId" >
            <Input hidden />
          </Form.Item>
          <Form.Item name="saleOrderId" >
            <Input hidden />
          </Form.Item>
          <Form.Item name="unitPrice" >
            <Input hidden />
          </Form.Item>
          <Form.Item name="index" >
            <Input hidden />
          </Form.Item>
          <Col xs={{span:24}} sm={{span:24}} md={{span:5}} lg={{span:5}} xl={{span:5}}>
            <Form.Item label="Item Category"
              name={'itemCategory'}
              rules={[{ required: true, message: 'Missing Item Category' }]}
            >
              <Select dropdownMatchSelectWidth={false} onSelect={getItemSubCategories} showSearch placeholder="Select Item Category" allowClear filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              disabled={props.isSo?true:false}
              >
                {props.isSo?props.stItems.map(dropData=>{
                  return dropDrownInfo(dropData.itemCategory, JSON.parse(dropData.itemCategory).itemCategory)
                }):props.itemCategories.map(dropData => {
                  return dropDrownInfo(JSON.stringify(dropData), dropData.itemCategory);
                })}

                
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{span:24}} sm={{span:24}} md={{span:5}} lg={{span:5}} xl={{span:5}}>
            <Form.Item label="Item Sub Category"
              name={'itemSubCategory'}
              rules={[{ required: true, message: 'Missing Item Sub Category' }]}
            >
              <Select dropdownMatchSelectWidth={false} showSearch placeholder="Select Item Sub Category" allowClear filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} onSelect={getItems}
               disabled={props.isSo?true:false}
              >
                {props.isSo?props.stItems.map(dropData=>{
                  return dropDrownInfo(dropData.itemSubCategory, JSON.parse(dropData.itemSubCategory).itemSubCategory)
                }):itemSubCategories.map(dropData => {
                  return dropDrownInfo(JSON.stringify(dropData), dropData.itemSubCategory)
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{span:24}} sm={{span:24}} md={{span:4}} lg={{span:4}} xl={{span:34}}>
            <Form.Item label="Item Name"
              name={'item'}
              rules={[{ required: true, message: 'Missing Item Name' }]}
            >
              <Select
                showSearch
                placeholder="Select Item"
                allowClear
                filterOption={(input, option) => option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0}
                onSelect={getAvailableQty}
                dropdownMatchSelectWidth={false}
                disabled={props.isSo?true:false}
              >
                {props.isSo?props.stItems.map(dropData=>{
                  return dropDrownInfo(dropData.item, JSON.parse(dropData.item).itemName)
                }):items.map(dropData => {
                  return dropDrownInfo(JSON.stringify(dropData), dropData.itemName)
                })}
              </Select>
            </Form.Item>
          </Col>

          {/* <Col span={4}>
            <Form.Item label="Size"
              name={'size'}
              rules={[{ required: true, message: 'Missing Size' }]}
            >
              <Select
                showSearch
                placeholder="Select size"
                allowClear
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onSelect={getAvailableQty}
                dropdownMatchSelectWidth={false}
              >
                {sizes.map(dropData => {
                  return dropDrownInfo(JSON.stringify(dropData), dropData.sizeName)
                })}
              </Select>
            </Form.Item>
          </Col> */}
          <Col xs={{span:24}} sm={{span:24}} md={{span:4}} lg={{span:4}} xl={{span:4}} className={props.isSo ? 'showColumn' : 'hideColumn'}>
            <Form.Item
              name={'requiredQty'}
              label={"Required Qty"}
              rules={[{ required: props.isSo, message: 'Missing Required Qty' }]}
            >
              <InputNumber min={0}  style={{ width: '100%' }} readOnly={true}/>
            </Form.Item>
          </Col>
          
            <Col xs={{span:24}} sm={{span:24}} md={{span:4}} lg={{span:4}} xl={{span:4}}>
            <label><span style={{ color: 'red' }}>*</span>Issuing Qty: <span style={{ color: 'red' }}>Avl. Qty :{availableQty}</span></label>
            <br />
            <Form.Item
              name={'issuedQty'}
              rules={[{ required: true, message: 'Missing Issuing Qty' }, {
                validator: (_, value) =>
                  value <= availableQty ? (value == 0) ? Promise.reject(new Error('Transferred Qty should be > 0')) : Promise.resolve() : Promise.reject(new Error('Quantity should be <= Available qty ' + availableQty)),
              }]}
            >
              <InputNumber min={0} max={availableQty} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col>
            <br />
            <br />
            <span>
              {!itemEdit ? <Tooltip placement="top" title='add'>
                <PlusSquareOutlined className={'editSamplTypeIcon'} type="add"
                  onClick={() => {
                    onAddProduct();
                  }}
                  style={{ color: '#1890ff', fontSize: '20px' }}
                />
              </Tooltip> : <Tooltip placement="top" title='edit'>
                <EditOutlined className={'editSamplTypeIcon'} type="edit"
                  onClick={() => {
                    onAddProduct();
                  }}
                  style={{ color: '#1890ff', fontSize: '20px' }}
                />
              </Tooltip>}

              <Divider type="vertical" />
              <Tooltip placement="top" title='clear'>
                <ClearOutlined onClick={() => {
                  clearItems();
                }}
                  style={{ color: 'red', fontSize: '20px' }} />
              </Tooltip>
            </span>
          </Col>
        </Row>

        {
          props.stItems.length ? <><Row gutter={24}>
            <Table
              key={keyUpdate}
              columns={columns}
              dataSource={props.stItems}
              bordered
              pagination={false}
              style={{ width: '100%' }} />
          </Row>
          </> : ''
        }
      </Form>
    </Card>
  );
}

export default PackingStockTransferItems;